import React from "react";
import { View, Text, ScrollView, Platform, StyleSheet } from "react-native";
import AppTheme from "../../AppTheme";
import AppMessages from "../../../../config/AppMessages";
import TreeNode from "./TreeNode";
import appStyles from "../../../appStyles";
import ManaButton from "../../common/ManaButton";

export default function TreeViewElements({
  userName,
  elements,
  isFinalStep = false,
  isTeamMember = false,
  openCreateElementDialog = () => {},
  onContinue = () => {},
}) {
  const title = isFinalStep
    ? `${userName}’s Life Elements`
    : `${userName}’s Work Elements`;

  const description = isTeamMember
    ? AppMessages.CustomizeElementsTeamSummary
    : isFinalStep
    ? AppMessages.CustomizeElementsPersonLifeElementsSummary
    : AppMessages.CustomizeElementsPersonSummary;

  return (
    <View style={{ flex: 1 }}>
      {userName ? <Text style={styles.title}>{title}</Text> : null}
      <Text style={styles.subTitle}>{description}</Text>

      <ScrollView
        contentContainerStyle={appStyles.scrollViewContent}
        style={[appStyles.scrollView, { paddingHorizontal: 2 }]}
      >
        {(elements || []).map((item) => (
          <TreeNode
            key={item.item_id}
            item={item}
            openCreateElementDialog={openCreateElementDialog}
          />
        ))}
      </ScrollView>

      <View style={appStyles.footerButtons}>
        <ManaButton
          isMainButton
          text={isFinalStep ? "Finish" : "Continue"}
          onPress={onContinue}
          style={[appStyles.bottomButton]}
          styleText={appStyles.bottomButtonText}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  title: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
    textAlign: "center",
  },
  subTitle: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Italic",
    }),
    fontStyle: "italic",
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    textAlign: "center",
    marginBottom: 11,
  },
  image: {
    marginBottom: "auto",
  },
});
